import store from "../store";
import { isEmpty } from "lodash";
export function generateTemplateSettings() {
  if (isEmpty(store.getters.SITE_SETTING.template_settings)) {
    console.log("template_settings empty");
    return {};
  } else {
    return store.getters.SITE_SETTING.template_settings;
  }
}

export function isCustomHomeEnabled() {
  return store.getters.TEMPLATE_SETTING.custom_home === true;
}

export function isProductAttributesEnabled() {
  return store.getters.TEMPLATE_SETTING.product_attributes === true;
}

export function isV2SelectMenu() {
  return store.getters.TEMPLATE_SETTING.select_menu_v2 === true;
}

export function isV2EditOrder() {
  return store.getters.TEMPLATE_SETTING.edit_order_v2 === true;
}
